import { Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export default function BackButton() {
  const navigate = useNavigate();

  return (
    <Button onClick={() => navigate(-1)} colorScheme="gray">
      前のページに戻る
    </Button>
  );
}
